/**
 * Lines Table Plugin
 */
(function ($) {

    "use strict";

    $.fn.linesTable = function (options) {

        const $parent = $(this);

        const $totalLineQuantity = $parent.find('#total-line-quantity')
        const $totalLinePrice = $parent.find('#total-line-price');
        let totalRows = $parent.find('tbody tr').length;

        const construct = {
            init : function () {
                let _this = this;

                /**
                 * Add an item
                 */
                $parent.on('click', '.add-row', function($e) {
                    $e.preventDefault();

                    totalRows++;

                    $parent.find('.remove-row').removeClass('disabled');

                    const newRow = $parent.find('tbody tr').first().clone();
                    newRow.find('.line-id').val('');
                    newRow.find('.line-description').removeClass('invalid').val('');
                    newRow.find('.line-quantity').removeClass('invalid').val('');
                    newRow.find('.line-unit-price').removeClass('invalid').val('');
                    newRow.find('.line-unit-ref').removeClass('invalid').val('');
                    newRow.find('.line-notes input').removeClass('invalid').val('');

                    $parent.find('tbody').append(newRow);
                });

                /**
                 * Remove an item
                 */
                $parent.on('click', '.remove-row', function($e) {
                    $e.preventDefault();

                    if (totalRows > 1) {
                        $(this).parent().parent().remove();
                        totalRows--;
                    }

                    if (totalRows === 1) {
                        $parent.find('tbody tr .remove-row').addClass('disabled');
                    }

                    _this.calculateTotals();
                });

                /**
                 * Format quantity
                 */
                $parent.on('blur', '.line-quantity', function($e) {
                    $e.preventDefault();

                    let self = $(this);
                    let value = self.val();
                    value = parseInt(value.replace(/\D/g,'')) || '';
                    self.val(value);

                    _this.calculateTotals();
                });

                /**
                 * Format price
                 */
                $parent.on('blur', '.line-unit-price', function($e) {
                    $e.preventDefault();

                    let self = $(this);
                    let value = self.val();
                    value = parseFloat(value.replace(/[^\d.]/g, '')).toFixed(2).replace(/[^\d.]/g, '') || '';
                    self.val(value);

                    _this.calculateTotals();
                });

                _this.calculateTotals();

                return _this;
            },

            calculateTotals: function () {
                let totalLineQuantity = 0;
                let totalLinePrice = 0;
                $parent.find('tbody tr').each(function () {
                    let row = $(this);
                    let lineQuantity = parseInt(row.find('.line-quantity').val() || 0);
                    let lineUnitPrice = parseFloat(row.find('.line-unit-price').val() || 0);
                    totalLineQuantity += lineQuantity;
                    totalLinePrice += lineQuantity * lineUnitPrice;
                });

                $totalLineQuantity.text(totalLineQuantity);
                $totalLinePrice.html('&pound;' + parseFloat(totalLinePrice).toFixed(2));
            },
        };

        const linesTable = $.extend(construct, {}, options);
        linesTable.init();

        return $parent;
    };

}(jQuery));
